export const INITIALIZE_DELAY = 3000
export const POSITION_UP_CLASS_NAME = 'up'
export const POSITION_DOWN_CLASS_NAME = 'down'
export const POSITION_SAME_CLASS_NAME = 'same'
export const CURRENT_USER_CLASS_NAME = 'current-user'
export const TOURNAMENT_WIDGET_POSITION_KEY = 'tournamentPosition'
